export default {
  checkInnResponse: [],
  checkPersonalInnResponse: [],
  checkPinResponse: [],
  innInfo: '',
  errors: {
    checkInnError: '',
    checkPersonalInnError: '',
    checkPinError: '',
    innInfoError: ''
  },
  isVisibleAuthForm: '',
  isShowBackBtn: false,
  loading: {
    checkPersonalInnLoading: false,
    pinConfirmLoading: false,
    checkInnLoading: false
  },
  sessionId: null
}



// WEBPACK FOOTER //
// ./src/store/auth/state.js